"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = exports.danger = exports.valid = exports.focus = exports.disabled = exports.enabled = void 0;

var _core = require("@emotion/core");

var _border = require("../border");

var enabled = function enabled(_ref) {
  var theme = _ref.theme;
  return (0, _core.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"])), (0, _border.thin)({
    theme: theme
  }), theme.bColorneutral05);
};

exports.enabled = enabled;

var disabled = function disabled(_ref2) {
  var theme = _ref2.theme;
  return (0, _core.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"])), (0, _border.thin)({
    theme: theme
  }), theme.bColorneutral04);
};

exports.disabled = disabled;

var focus = function focus(_ref3) {
  var theme = _ref3.theme;
  return (0, _core.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"])), (0, _border.thin)({
    theme: theme
  }), theme.bColorsecondary05);
};

exports.focus = focus;

var valid = function valid(_ref4) {
  var theme = _ref4.theme;
  return (0, _core.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"])), (0, _border.thin)({
    theme: theme
  }), theme.bColorsuccess);
};

exports.valid = valid;

var danger = function danger(_ref5) {
  var theme = _ref5.theme;
  return (0, _core.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"])), (0, _border.thin)({
    theme: theme
  }), theme.bColordanger);
};

exports.danger = danger;

var warning = function warning(_ref6) {
  var theme = _ref6.theme;
  return (0, _core.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  border-color: ", ";\n"])), (0, _border.thin)({
    theme: theme
  }), theme.bColorwarning);
};

exports.warning = warning;